import axios from 'axios';
import {
  useCallback,
} from 'react';

import { baseUrl } from '../helpers/urls';
import { useCurrentUser } from '../contexts/CurrentUser.context';

const useWallets = () => {

  const {token} = useCurrentUser()

  const getById = useCallback(async ({compId, walletId}) => {
    const response = await axios({
      method: 'GET',
      url: `${baseUrl}/companies/${compId}/wallets/${walletId}`, 
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });
 
    return response.data;
  }, []);

  const getByCode = useCallback(async ({walletCode}) => {
    const response = await axios({
      method: 'GET',
      url: `${baseUrl}/wallets/${walletCode}`});
 
    return response.data;
  }, []);

  const getUsersOfWallet = useCallback(async ({walletCode, searchTerm}) => {
    const response = await axios({
      method: 'GET',
      url: `${baseUrl}/wallets/${walletCode}/users`,
      params:{
        searchTerm
      }, 
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });
 
    return response.data;
  }, [token]);

  const getTransactionsOfWallet = useCallback(async ({compId, walletId, start, end}) => {
    const response = await axios({
      method: 'GET',
      url: `${baseUrl}/companies/${compId}/wallets/${walletId}/transactions`, 
      params: {
        start,
        end
      },
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });
 
    return response.data;
  });

  const getStockOfWallet = useCallback(async ({walletId, limit}) => {
    const response = await axios({
      method: 'GET',
      url: `${baseUrl}/wallets/${walletId}/products`, 
      params: {
        'limit': limit
      },
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });
 
    return response.data;
  });

  const updateStockOfWallet = useCallback(async ({walletId, productId, quantity, price}) => {
    const response = await axios({
      method: 'PUT',
      url: `${baseUrl}/wallets/${walletId}/products/${productId}`, 
      params: {
        'quantity': quantity,
        "price": price
      },
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
    return response.data
  });

  const getStats = useCallback(async ({walletCode, month, year}) => {
    console.log("yoelee")
    const response = await axios({
      method: 'GET',
      url: `${baseUrl}/wallets/${walletCode}/stats`, 
      params: {
        'month': month,
        "year": year
      },
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
    console.log(response.data)
    return response.data
  }, [token]);

  const createWallet = useCallback(async (compId, {name, description}) => {
    const response = await axios({
      method: 'POST',
      url: `${baseUrl}/companies/${compId}/wallets`,
      data: {name, description},
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });

    console.log(response);
    return response.data;
  });

  const deleteWallet = useCallback(async ({compId, walletId}) => {
    const response = await axios({
      method: 'DELETE',
      url : `${baseUrl}/companies/${compId}/wallets/${walletId}`,
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });
  });

  return {
    createWallet,
    getById,
    getByCode,
    getStats,
    getStockOfWallet,
    getUsersOfWallet,
    getTransactionsOfWallet,
    deleteWallet,
    updateStockOfWallet
  };

};

export default useWallets;